export class Constants {

    /**
     * Default request headers
     */
    public static readonly DEFAULT_REQUEST_HEADERS = {
        'content-type': 'application/json'
    };

    /**
     * DScribe resource bundle
     */
    public static readonly RESOURCE_BUNDLE_PREFIX_WDW = 'awakening-calendar.';
    public static readonly RESOURCE_BUNDLE_PREFIX_DLR = 'dlr.site.cmsResourceBundle.awakening-calendar.';

    /**
     * HTTP request types
     */
    public static readonly REQUEST_TYPE_GET = 'get';
    public static readonly REQUEST_TYPE_POST = 'post';

    /**
     * Cookie names
     */
    public static readonly COOKIE_LOCALE = 'localeCookie_jar_aka';
    public static readonly COOKIE_LANGUAGE = 'languageSelection_jar_aka';
    public static readonly COOKIE_CONVERSATION_ID = 'PHPSESSID';

    /**
     * Locale/language cookies properties
     */
    public static readonly CONTENT_LOCALE = 'contentLocale';
    public static readonly PREFERRED_LANGUAGE = 'preferredLanguage';

    /**
     * Park status
     */
    public static readonly PARK_AVAILABLE = 'available';
    public static readonly PARK_UNAVAILABLE = 'unavailable';

    /**
     * Availability types
     */
    public static readonly AVAILABILITY_FULL = 'full';
    public static readonly AVAILABILITY_PARTIAL = 'partial';
    public static readonly AVAILABILITY_NONE = 'none';

    /**
     * Query params
     */
    public static readonly PARAM_LOCALE = 'locale';
    public static readonly PARAM_SEGMENTS = 'segments';
    public static readonly PARAM_DEFAULT_SEGMENT = 'defaultSegment';
    public static readonly PARAM_DEFAULT_DATE = 'startDate';
    public static readonly PARAM_CONTENT_KEY= 'awakening-calendar';

    /**
     * Date information
     */
    public static readonly DATE_RAW = 'raw';
    public static readonly DATE_PRETTY = 'pretty';
    public static readonly DATE_ANALYTICS = 'analytics';
    public static readonly DATE_MONTH_AVAIL_ANALYTICS = 'monthAvailAnalytics';

    public static readonly DATE_FORMAT_PRETTY = 'LL';
    public static readonly DATE_FORMAT_RAW = 'YYYY-MM-DD';
    public static readonly DATE_FORMAT_ANALYTICS = 'MM/DD/YYYY';
    public static readonly DATE_FORMAT_MONTH_AVAIL_ANALYTICS = 'MMMMYY';

    public static readonly DATE_UNIT_DAYS = 'days';
    public static readonly DATE_UNIT_MONTH = 'month';

    /**
     * Availability restriction types
     */
    public static readonly AVAILABILITY_RESTRICTION_TYPES = {
        'range': 'range',
        'specific': 'specific'
    };

    /**
     * Availability restriction default value
     */
    public static readonly AVAILABILITY_RESTRICTION_DEFAULT_RANGE = '180';

    /**
     * Localization and language data
     */
    public static readonly SUPPORTED_LOCALES = {
        'en-us': ['en-us', 'en-ca'],
        'es-us': ['es-us', 'es-ar', 'es-mx', 'es-pe', 'es-co', 'es-cl'],
        'pt-br': 'pt-br',
        'fr-ca': 'fr-ca'
    };

    public static readonly DEFAULT_PREFERRED_LANGUAGE = 'en-us';

    /**
     * Analytics data
     */
    public static readonly ANALYTICS_PAGE_VIEW_TRACKING_TIME = 10000;

    public static readonly ANALYTICS_TRACKING_TYPE = 'customLink';
    public static readonly ANALYTICS_CHANGE_VARIANT = 'changeVariant';

    public static readonly ANALYTICS_LINK_ID_INITIAL_AVAIL = '%s_AdmissionCalendar_InitialParkAvail';
    public static readonly ANALYTICS_LINK_ID_CHECK_AVAIL = '%s_AdmissionCalendar_CheckParkAvail';
    public static readonly ANALYTICS_LINK_ID_EXIT_MODULE = '%s_AdmissionCalendar_ExitModule';
    public static readonly ANALYTICS_LINK_ID_MONTH_NEXT = '%s_AdmissionCalendar_AdvanceCarousel';
    public static readonly ANALYTICS_LINK_ID_MONTH_PREVIOUS = '%s_AdmissionCalendar_RetreatCarousel';
    public static readonly ANALYTICS_LINK_ID_TIER_TOGGLE = '%s_AdmissionCalendar_%s_Toggle';

    public static readonly ANALYTICS_EVENT_TYPE_PAGE_LOAD = 'pageLoad';
    public static readonly ANALYTICS_EVENT_TYPE_SEGMENT_CHANGED = 'newSegmentSelected';
    public static readonly ANALYTICS_EVENT_TYPE_DATE_CHANGED = 'newDateSelected';
    public static readonly ANALYTICS_EVENT_TYPE_MONTH_NEXT = 'monthAdvance';
    public static readonly ANALYTICS_EVENT_TYPE_MONTH_PREVIOUS = 'monthRetreat';

    public static readonly ANALYTICS_ITEM_PARK_AVAILABILITY_ID = 'ADMResCalPark';
    public static readonly ANALYTICS_ITEM_MONTH_AVAILABILITY_ID = 'ADMResCalMonth';

    public static readonly ANALYTICS_SEGMENT_TICKETS = 'SingleParkTicketOnly';
    public static readonly ANALYTICS_SEGMENT_RESORT = 'ResortGuest';
    public static readonly ANALYTICS_SEGMENT_PASSHOLDER = 'Passholder';
    public static readonly ANALYTICS_SEGMENT_PARKHOPPER = 'ParkHopperTicketOnly';

    public static readonly ANALYTICS_MONTH_AVAIL_FULL = '%sFullAvail';
    public static readonly ANALYTICS_MONTH_AVAIL_PARTIAL = '%sPartialAvail';
    public static readonly ANALYTICS_MONTH_AVAIL_NONE = '%sUnavail';
}
